import { Drug } from './drug.model';
import { MedicalTest } from './medical-test.model';

export interface Cart {
  id?: number;
  userId?: number;
  medicalTestIds?: number[];
  quantity?: number[];
  medical_tests?: MedicalTest[];
  medical_consultation?: boolean;
}

export interface CartCostOptions {
  items: (MedicalTest | Drug)[];
  itemQuantities: { [key: number]: number };
  itemAmounts: { [key: number]: string };
  isDrug: boolean;
  addConsultation: boolean;
  consultationAmount: number;
  selectedQuantityTypeIds?: number[];
  quantities?: number[];
}
  